import React,{useState, useEffect} from 'react';
import Table from 'react-bootstrap/Table'
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jkeyword(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
  <Sides/>
  <Helmet>
 
 <title>Java keyword tutorial For Beginners</title>
<meta name="description" content="Java Keywords tutorial for beginners.hese keywords cannot be used as identifiers, they cannot be used as names for a variable, class, or method" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java keyword,java keyword final,java keyword this,java keywords
,java keyword transient,java keyword new,java keyword list,java keywords list,java keyword extends,what is java keyword,java keywords pdf,how many keyword in java" />
<link rel="canonical" href="https://www.codeexampler.com/java-keywords"/>
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Java keyword</h1>
    <div className="first">
        <a href="/java-operators">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Java keyword programming table </h2>
   <p className="mt-4 para">1, These keywords cannot be used as identifiers. They cannot be used as names for a variable, class, or method<br/>
   2, Java Programming keywords are Known as Reserved Words.
   </p>
    <Table responsive striped bordered hover variant="dark m-3">
 
  <tbody>
    <tr>
      <td>Catch</td>
      <td>final</td>
      <td>module</td>
      <td>Short</td>
      <td>try</td>
      <td>Abstract</td>
      <td>do</td>
      <td>implements</td>
      <td>Private</td>
      <td>this</td>
    </tr>
    <tr>
    <td>Char</td>
      <td>finally</td>
      <td>native</td>
      <td>static</td>
      <td>uses</td>
      <td>assert</td>
      <td>double</td>
      <td>import</td>
      <td>protected</td>
      <td>throw</td>
    </tr>
    <tr>
      <td>class</td>
      <td>float</td>
      <td>new</td>
      <td>strictfp</td>
      <td>void</td>
      <td>boolean</td>
      <td>else</td>
      <td>instanceof</td>
      <td>provides</td>
      <td>throws</td>
    </tr>

    <tr>
      <td>const</td>
      <td>enum</td>
      <td>int</td>
      <td>public</td>
      <td>to</td>
      <td>break</td>
      <td>enum</td>
      <td>int</td>
      <td>public</td>
      <td>to</td>
      
      
    </tr>

    <tr>
      <td>continue</td>
      <td>exports</td>
      <td>interface</td>
      <td>requires</td>
      <td>transiet</td>
      <td>byte</td>
      <td>exports</td>
      <td>interface</td>
      <td>requires</td>
      <td>transient</td>
    </tr>

    <tr>
      <td>default</td>
      <td>if</td>
      <td>package</td>
      <td>synchronized</td>
      <td>with</td>
      <td>case</td>
      <td>extends</td>
      <td>long</td>
      <td>return</td>
      <td>transitive</td>
    </tr>
  </tbody>
</Table>
  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/java-operators">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jkeyword;